module.exports = __webpack_public_path__ + "img/file-code-01.df1aea7f.svg";